<div class="container-fluid paddingright">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">View Tracker Invoice</h1>
        <button class="btn btn-dark btn-sm" mat-raised-button matTooltip="Back" matTooltipPosition="left"
          (click)="backTo()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>

      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item active" aria-current="page">
            Manage Tracker
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            View Tracker Invoice
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <!-- ================= FILTER FORM ================= -->
  <div class="contentbox w-90vw mt-3">
    <form [formGroup]="filterform">
      <div class="row">
        <!-- Company -->
        <div class="col-md-4">
          <div class="form-group accountsinp mb-3">
            <label>Company Name</label>
            <select id="clientNamectrl" formControlName="clientName" class="form-control shadow-none"
              (change)="onClientChange($event)">
              <option value="">--Select Company Name--</option>
              <option *ngFor="let c of clientList" [value]="c._id">
                {{ c.clientName }}
              </option>
            </select>
          </div>
        </div>


        <!-- Invoice Type -->
        <div class="col-md-4">
          <div class="form-group accountsinp mb-3">
            <label>Invoice Type</label>
            <select id="invoiceTypectrl" formControlName="invoiceType" class="form-control shadow-none">
              <option value="">--Select Invoice Type--</option>
              <option *ngFor="let s of invoiceType" [value]="s.value">
                {{ s.invoiceTypeName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Tracker No -->
        <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
          <label>Tracker No.<sup class="text-danger">*</sup></label>
          <div class="form-group accountsinp mb-3">
            <ng-multiselect-dropdown formControlName="Tracker_no" [placeholder]="'Select Tracker No.'"
              [settings]="dropdownSettings" [data]="trackerNumber">
            </ng-multiselect-dropdown>
          </div>
        </div>



        <!-- Generate Button -->
        <div class="col-xl-12 text-end">
          <button class="btn btn-dark ms-2" type="submit" mat-raised-button (click)="generateTrackerInvoicePreview()">
            Invoice Generate
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- ================= TABLE ================= -->
  <div class="contentbox w-90vw mt-3">
    <div class="row">
      <div class="col-xl-3 ms-auto">
        <input class="search-box form-control" placeholder="Search" type="text"
          (keyup)="filterData($event.target.value)" />
      </div>

      <div class="col-md-12">
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" matSort matSortActive="created_date" matSortDirection="desc"
            class="row-border hover tablelist">
            <!-- S.No -->
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef>S.no</th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ paginator.pageIndex * paginator.pageSize + (i + 1) }}
              </td>
            </ng-container>


            <ng-container matColumnDef="billNo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Bill No
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row?.billNo }}
              </td>
            </ng-container>



            <!-- Company -->
            <ng-container matColumnDef="clientName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Company Name
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row?.clientName }}
              </td>
            </ng-container>

            <!-- Date -->
            <ng-container matColumnDef="created_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
              <td mat-cell *matCellDef="let row">
                {{ row.created_date | date : "yyyy-MM-dd" }}
              </td>
            </ng-container>

            <!-- Action -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Action
              </th>
              <td mat-cell *matCellDef="let row">
                <div class="d-flex justify-content-center align-items-center">
                  <button class="btn btn-block" (click)="viewTrackerInvoice(row._id)">
                    <i matTooltip="View" class="fa-solid fa-eye"></i>
                  </button>
                  <button (click)="getParticularInvoice(row._id)" class="btn btn-block">
                    <i matTooltip="Print" class="fas fa-print"></i>
                  </button>

                  <button class="btn btn-block" (click)="sendInvoice('print-section', row._id)">
                    <i matTooltip="Send" class="fa fa-paper-plane"></i>
                  </button>

                  <button class="btn btn-block" (click)="deleteTrackerInvoice(row._id)">
                    <i matTooltip="Delete" class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator #paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <!-- HIDDEN PRINT BUTTON FOR ngxPrint -->
  <button #printBtn [useExistingCss]="true" ngxPrint printSectionId="print-section" style="display: none;"></button>

  <!-- ================= PRINT SECTION (Hidden) - Fixed Rate Invoice ================= -->
  <div class="row mt-3" *ngIf="showFixedRateTable" id="print-section" style="display: none !important;">
    <div class="col-xl-12">
      <div class="contentbox">
        <div class="NewInvoice-table table-responsive" #printSection>
          <div class="invoice-wrapper">
            <table class="newInvoiceBox">
              <!-- TOP INFO -->
              <tr>
                <td colspan="18" class="newtable">
                  <table>
                    <tr>
                      <td><strong>Name of Transporter:</strong></td>
                      <td colspan="5">Radha Swami</td>
                    </tr>
                    <tr>
                      <td><strong>DC No:</strong></td>
                      <td>{{ getTopDisplayValue(users?.[0]?.dcNo?.[0]) }}</td>
                    </tr>
                    <tr>
                      <td><strong>Month:</strong></td>
                      <td>{{ invoiceMonth }}</td>
                    </tr>
                    <tr>
                      <td><strong>Location:</strong></td>
                      <td>{{ getTopDisplayValue(users?.[0]?.location?.[0]) }}</td>
                    </tr>
                    <tr>
                      <td><strong>Invoice No:</strong></td>
                      <td colspan="2">{{ billno || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td><strong>Invoice Date (DD MMMM, YYYY)</strong></td>
                      <td colspan="2">{{ invoiceDate }}</td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td class="newtable-row">
                  <table>
                    <!-- HEADER -->
                    <thead>
                      <tr>
                        <th rowspan="2">SL No</th>
                        <th rowspan="2">Vehicle No</th>
                        <th rowspan="2">Capacity</th>
                        <th rowspan="2">Working Days</th>
                        <th rowspan="2">Actual Working Days</th>
                        <th rowspan="2">Fixed Km</th>
                        <th rowspan="2">Total Km</th>
                        <th rowspan="2">Extra Km</th>
                        <th rowspan="2">Extra Km Cost</th>
                        <th rowspan="2">Extra Hrs</th>
                        <th rowspan="2">Variable Cost/Hr</th>
                        <th rowspan="2">Fixed Amount</th>
                        <th colspan="1">Fixed Amt/Month</th>
                        <th colspan="1">Amount for KM</th>
                        <th colspan="1">Amount for Extra Hrs</th>
                        <th colspan="1">Toll/Parking</th>
                        <th colspan="1">Incentive / Halting</th>
                        <th rowspan="2">Total Amount <br>A + B + C + D</th>
                      </tr>
                      <tr>
                        <th>(A)</th>
                        <th>(B)</th>
                        <th>(C)</th>
                        <th>(D)</th>
                        <th>(E)</th>
                      </tr>
                    </thead>

                    <!-- DATA ROWS -->
                    <tbody *ngFor="let user of users">
                      <tr *ngFor="let vehicle of user.vehicle_id; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ getDisplayValue(user.vehicle_id?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.vehicleType?.[i]) }}</td>
                        <td>28</td>
                        <td>{{ getActualWorkingDays(user.tripStartDate?.[i], user.tripEndDate?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.fixedKM?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.up_down_km?.[i]) }}</td>
                        <td>{{ getDisplayValue(getExtraKmVal(user, i)) }}</td>
                        <td>{{ getDisplayValue(user.extraKMCost?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.extrahour?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.variableCostHr?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.fixedPayment?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.fixedPaymentMonth?.[i]) }}</td>
                        <td>{{ getDisplayValue(getAmountForKm(user, i)) }}</td>
                        <td>{{ getDisplayValue(getAmountForExtraHrs(user, i)) }}</td>
                        <td>{{ getDisplayValue(user.tooltaxPaid?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.otherPayment?.[i]) }}</td>
                        <td>{{ getDisplayValue(getRowTotalAmount(user, i)) }}</td>
                      </tr>

                      <!-- SUMMARY -->
                      <tr class="summary-row">
                        <td colspan="17">Total Dedicated Vehicle amount</td>
                        <td><strong>{{ getGrandTotal(users) > 0 ? (getGrandTotal(users) | number:'1.2-2') : '-' }}</strong></td>
                      </tr>
                      <tr class="summary-row">
                        <td colspan="17"><strong>Add:</strong> Man Power</td>
                        <td>-</td>
                      </tr>
                      <tr class="summary-row">
                        <td colspan="17"><strong>Add:</strong> Flooring Charges</td>
                        <td>-</td>
                      </tr>
                      <tr class="summary-row">
                        <td colspan="17">Night operation charges</td>
                        <td>-</td>
                      </tr>
                      <tr class="summary-row">
                        <td colspan="17">Additional Labour</td>
                        <td>-</td>
                      </tr>
                      <tr class="summary-row">
                        <td colspan="17"><strong>Less:</strong> Cash collection</td>
                        <td>-</td>
                      </tr>
                      <tr class="summary-row total-payable-row">
                        <td colspan="17"><strong>Total Payable</strong></td>
                        <td><strong>{{ getGrandTotal(users) > 0 ? (getGrandTotal(users) | number:'1.2-2') : '-' }}</strong></td>
                      </tr>

                      <!-- FOOTER -->
                      <tr>
                        <td colspan="18" style="border: 1px solid #000; padding: 10px;">
                          We hereby confirmed that all the Invoice copies duly acknowledged by the customers have
                          received and above details are found correct.
                        </td>
                      </tr>

                      <!-- SIGNATURE -->
                      <tr>
                        <td colspan="6" style="border: 1px solid #000; padding: 20px; text-align: center;">
                          <strong>Prepared By</strong><br><br>
                          Name<br>Designation
                        </td>
                        <td colspan="6" style="border: 1px solid #000; padding: 20px; text-align: center;">
                          <strong>Verified By</strong><br><br>
                          Name<br>Designation
                        </td>
                        <td colspan="6" style="border: 1px solid #000; padding: 20px; text-align: center;">
                          <strong>Authorized Signatory</strong><br><br>
                          Name<br>Designation
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= SPINNER ================= -->
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</div>